import cc from 'store/util/createReduxConstant';

export const FETCH_ADDR_INTERNAL_NAME = cc('FETCH_ADDR_INTERNAL_NAME');
export const FETCH_ADDR_INTERNAL_NAME_SUCCESS = cc('FETCH_ADDR_INTERNAL_NAME_SUCCESS');
export const FETCH_ADDR_INTERNAL_NAME_FAIL = cc('FETCH_ADDR_INTERNAL_NAME_FAIL');

export const FETCH_ADDR_NAME = cc('FETCH_ADDR_NAME');
export const FETCH_ADDR_NAME_SUCCESS = cc('FETCH_ADDR_NAME_SUCCESS');
export const FETCH_ADDR_NAME_FAIL = cc('FETCH_ADDR_NAME_FAIL');
